






































































































































import Vue from 'vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XZipInput from '@/components/atoms/Input/XZipInput.vue'
import XTel from '@/components/atoms/Input/XTel.vue'
import { AddressResponse } from '@/mixin/zipcodeMixin'
import { CreateStoreApplicationInput } from '@/types/generated/graphql'
import PrefPicker from '@/components/molecules/PrefPicker/PrefPicker.vue'
import IndustryPicker from '@/components/molecules/IndustryPicker/IndustryPicker.vue'

type Props = {
  nth: number
  value: CreateStoreApplicationInput
}

export default Vue.extend<{}, {}, {}, Props>({
  name: 'Store',
  components: {
    XCard,
    XFormLabel,
    XZipInput,
    XTel,
    PrefPicker,
    XInput,
    IndustryPicker,
  },
  props: {
    nth: {
      type: Number,
      required: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setAddress(address: AddressResponse) {
      this.value.prefId = address.prefId
      this.value.address1 = address.locality + address.street
    },
  },
})
